import React from 'react';
import styled from 'styled-components';
import { useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Link from '@material-ui/core/Link';
import { NavLink } from 'react-router-dom';
import { ReactComponent as LogoWhite } from '../../../resources/images/logo-white.svg';
import { ReactComponent as AppCloseIcon } from '../../../resources/images/close.svg';
import { ReactComponent as AppMenuIcon } from '../../../resources/images/menu.svg';
import { ReactComponent as ChatIcon } from '../../../resources/images/chat.svg';
import { ReactComponent as InfoIcon } from '../../../resources/images/info.svg';
import AppBar from '@material-ui/core/AppBar';
import produce from 'immer';
import { MobileNavBarStyle as useStyles, getActiveMobileLinkStyles, MobileMenuLogo } from '../../../styles/MobileNavBarStyle';
import { CURRENT_APP_THEME } from '../../../styles/stylesSelector';
import { ReactComponent as BackIcon } from '../../../resources/images/back.svg';
import { Box, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { PATH_CHAT, PATH_HOME } from '../../../containers/RoutePaths';
import UnreadMessageBadge from './UnreadMessageBadge';
import { MenuLinks } from './AdaptiveNavBar';

const isWatchman = process.env.REACT_APP_THEME_ENV === 'watchman';

const MobileStyledNavLink = styled(NavLink)`
    &&& {
        font-style: normal;
        font-weight: 600;
        text-decoration: none;
        line-height: 41px;
        letter-spacing: 0.16px;
        font-family: ${props => props.theme.typography.fontFamily};
        color: ${props => props.theme.palette.primary.contrastText};
        font-size: ${props => props.theme.typography.body1.fontSize};
        margin-left: ${props => `${props.theme.spacing(6)}px`};
        margin-top: ${props => `${props.theme.spacing(5)}px`};
    }
`;

function ListLinkItem({ link, children }) {
    const classes = useStyles();
    const theme = useTheme();

    // use immer to avoid mutating the theme object
    const themeCopy = produce(theme, draftTheme => {
        draftTheme.typography.body1.fontSize = theme.typography.h1.fontSize;
    });

    const activeLinkStyles = getActiveMobileLinkStyles(theme);
    return (
        <MobileStyledNavLink
            to={link}
            activeStyle={{
                color: activeLinkStyles.color,
                borderBottom: activeLinkStyles.borderBottom,
            }}
            theme={themeCopy}
            className={classes.linkItem}
        >
            {children}
        </MobileStyledNavLink>
    );
}

const LinkList = () => {
    const classes = useStyles();
    const menuLinks = MenuLinks();

    return (
        <div className={classes.list}>
            {menuLinks.map((item, index) => (
                <ListLinkItem link={item.link} key={index}>
                    {item.text}
                </ListLinkItem>
            ))}
        </div>
    );
};

const MenuCard = ({ clickHandler }) => {
    const classes = useStyles();

    return (
        <div className={classes.menuCard}>
            <div className={classes.iconContainer}>
                <LogoWhite aria-labelledby={`${CURRENT_APP_THEME} logo`} />
                <AppCloseIcon title={'close icon'} onClick={clickHandler} className={classes.closeIcon} />
            </div>
            <LinkList />
        </div>
    );
};

const MobileAppBar = ({ clickHandler, isErrorPageHeader }) => {
    const classes = useStyles();
    const history = useHistory();

    const chatClickHandler = e => {
        //TODO: navigate to chat page
        history.push(PATH_CHAT);
    };

    // TODO: set the value of isChatSupported based on chat functionality from backend
    const isChatSupported = isWatchman;
    return (
        <AppBar
            position={isErrorPageHeader ? 'relative' : 'static'}
            classes={{
                root: classes.appBar,
            }}
        >
            <div className={classes.toolBar}>
                {isChatSupported && <UnreadMessageBadge children={<ChatIcon title={'chat icon'} onClick={chatClickHandler} className={classes.chatIcon} />} />}
                <Link to={'#'} onClick={() => history.push(PATH_HOME)}>
                    <MobileMenuLogo aria-labelledby={`${CURRENT_APP_THEME} logo`} className={classes.logoImage} />
                </Link>
                <AppMenuIcon title={'menu icon'} onClick={clickHandler} className={classes.menuIcon} />
            </div>
        </AppBar>
    );
};

export default function MobileNavBar({ isErrorPageHeader }) {
    const [state, setState] = React.useState(false);

    const toggleDrawer = open => {
        setState(open);
    };

    return (
        <>
            <MobileAppBar clickHandler={() => toggleDrawer(true)} isErrorPageHeader={isErrorPageHeader} />
            <Drawer anchor={'right'} open={state} onClose={() => toggleDrawer(false)}>
                <MenuCard clickHandler={() => toggleDrawer(false)} />
            </Drawer>
        </>
    );
}

export function MobileNavBarWithInfo({ isErrorPageHeader, infoClickHandler, headerTitle }) {
    const [state, setState] = React.useState(false);
    const classes = useStyles();
    const history = useHistory();

    const toggleDrawer = open => {
        setState(open);
    };

    return (
        <>
            <AppBar
                position="fixed"
                    classes={{
                        root: classes.appBar,
                    }}
                >
                <div className={clsx(classes.toolBar, classes.navWithInfoToolBar)}>
                    <BackIcon title={'back icon'} className={classes.backIcon} onClick={() => history.goBack()}/>
                    <Typography variant="h2" className={classes.headerTitle}>{headerTitle}</Typography>
                    <Box display="flex" alignItems="center">
                        <InfoIcon className={classes.infoIcon} onClick={infoClickHandler}/>
                        <AppMenuIcon title={'menu icon'} onClick={() => toggleDrawer(true)} className={classes.menuIcon} />
                    </Box>
                </div>
            </AppBar>
            <Drawer anchor={'right'} open={state} onClose={() => toggleDrawer(false)}>
                <MenuCard clickHandler={() => toggleDrawer(false)} />
            </Drawer>
        </>
    );
}
